// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_MYy","cls2":"ReferenceCard-cls2_Rdo ReferenceCard-cls1_MYy"};